import React from "react";
import "../App.css";
import "../sections/Projects.css";
import projects from "../data/projects.json";

const Projects = () => (
  <section id="projects" className="projects-section">
    <h1 id="projects-header">Projects</h1>

    <div className="project-tiles">
      {projects.map((project, index) => (
        <div className="project-card" key={index}>
          <img
            src={project.image}
            alt={project.title}
            className="project-image"
          />
          <h3 className="project-title">{project.title}</h3>
          <div className="project-tags">
            {project.tags.map((tag, i) => (
              <span className="project-tag" key={i}>
                {tag}
              </span>
            ))}
          </div>
          <p className="project-description">{project.description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Projects;
